      
/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-08-15 09:08:45
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-12-15 17:45:17
 * @FilePath: \vue-hepha-order\src\layout\Menu.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

// 菜单权限   角色-- 1：system   2：control   3：base  4：finance   5：hepha/warehouse  6:zu    
//                  7:new_ouda   8:audits  10:sales assistant  11：CEO  12:sale_manager  13:B2B  14:B2C  15:export   16: hepha审厂(hepha_customs)  17:supply_chain
const menus = [
    // {
    //     name:'数据看板',
    //     key:'Dashboard',
    //     link:'/Dashboard',
    //     icon:'IconDashboard',
    //     locale:'menu.dashboard',
    //     auth:['1','2', '4', '10', '12','13','15'],
    //     children:[
    //         // {
    //         //     name:'数据看板',
    //         //     key:'Dashboard',
    //         //     link:'/Dashboard/Dashboard',
    //         //     icon:'IconDashboard',
    //         //     locale:'menu.dashboard',
    //         //     auth:['1','2', '4', '10', '12','13','15'],
    //         // },
    //         {
    //             name:'KPI日报表',
    //             key:'KpiDailyReport',
    //             link:'/KpiDailyReport',
    //             icon:'IconBook',
    //             locale:'menu.kpiDailyReport',
    //             auth:['1','2','4','10','12']
    //         },
    //     ]
    // },
    {
        name:'订单管理',
        key:'OrderList',
        link:'/OrderList',
        icon:'IconApps',
        locale:'menu.orderList',
        auth:['1','2','3','4','5','6','7','8','10','12','13','15','16','18'], 
        children:[
            {
                name:'订单列表',
                key:'OrderList',
                link:'/OrderList/OrderList',
                icon:'IconList',
                locale:'menu.orderSubList',
                auth:['1','2','3','4','5','6','7','8','10','12','13','15','16','18']
            },
            {
                name:'发票管理',
                key:'InvoiceList',
                link:'/OrderList/InvoiceList',
                icon:'IconFile',
                locale:'menu.invoiceList',
                auth:['1','2','3','4','8','10','12','13','15','16','18']
            },
            {
                name:'经销商未完结订单',
                key:'DealerOpenOrderList',
                link:'/OrderList/DealerOpenOrderList',
                icon:'IconOrderedList',
                locale:'menu.dealerOpenOrder',
                auth:['1','2','4','5','8','10','12','13','15','16','18']
            },
            {
                name:'B2B Shop订单管理',
                key:'B2BShopOrderList',
                link:'/OrderList/B2BShopOrderList',
                icon:'IconList',
                locale:'menu.B2BShopOrderList',
                auth:['1','8','10','12','18']
            },
            {
                name:'预售订单',
                key:'PreSaleOrder',
                link:'/OrderList/PreSaleOrder',
                icon:'IconTranslate',
                locale:'menu.preSaleOrder',
                auth:['1','2','3','4','5','6','7','8','10','12','13','15','16','18']
            },
            {
                name:'预付款订单管理',
                key:'PrepaidOrder',
                link:'/OrderList/PrepaidOrder',
                icon:'IconCommon',
                locale:'menu.prepaidOrderList',
                auth:['1','2','3','4','5','6','7','8','10','12','13','15','18']
            },
            // {
            //     name:'数据统计',
            //     key:'DataStatistics',
            //     link:'/OrderList/DataStatistics',
            //     icon:'IconBarChart',
            //     locale:'menu.dataStatistics'
            // },
        ]
    },
    // {
    //     name:'预付款订单管理',
    //     key:'PrepaidOrder',
    //     link:'/PrepaidOrder',
    //     icon:'IconCommon',
    //     locale:'menu.prepaidOrderList',
    //     auth:['1','2','3','4','5','6','7','8','10','12','13','15']
    // },
    {
        name:'库存',
        key:'Deliver',
        link:'/Deliver',
        icon:'IconLayers',
        locale:'menu.eBikeAvailability',
        auth:['1','2','3','4','5','6','7','8','10','12','13','15','17','18'],
        children:[
            {
                name:'交付报表',
                key:'BomQuery',
                link:'/Deliver/AvailabilityReport',
                icon:'IconMindMapping',
                locale:'menu.availabilityReport',
                auth:['1','2','3','4','5','8','10','12','13','15','17','18'],
            },
            {
                name:'库存锁定',
                key:'InventoryLockList',
                link:'/InventoryLockList',
                icon:'IconLock',
                locale:'menu.inventoryLock',
                auth:['1','2','3','4','5','6','7','8','10','12','13','15','16','18']
            },
            {
                name:'整车部件查询',
                key:'BomQuery',
                link:'/Product/BomQuery',
                icon:'IconSearch',
                locale:'menu.bomQuery',
                auth:['1','2','3','4','5','8','10','12','13','15','18'],
            },
        ]
    },
    {
        name:'出库',
        key:'Outbounds',
        link:'/Outbounds',
        icon:'IconStorage',
        locale:'menu.outbounds',
        auth:['1','2','3','4','5','6','7','8','10','12','13','15','16','18'],
        children:[
            {
                name:'出库管理',
                key:'StockOutList',
                link:'/Outbounds/StockOutList',
                icon:'IconStorage',
                locale:'menu.stockOutList',
                auth:['1','2','3','4','5','6','7','8','10','12','13','15','16','18']
            },
            {
                name:'预警管理',
                key:'WarningList',
                link:'/Outbounds/WarningList',
                icon:'IconBulb',
                locale:'menu.warningList',
                auth:['1','2','18']
            },
        ]
    },
    {
        name:'客户',
        key:'Customers',
        link:'/Customer',
        icon:'IconUser',
        locale:'menu.customers',
        auth:['1','2','3','4','5','6','7','8','10','12','13','15','16','18'],
        children:[
            {
                name:'客户管理',
                key:'CustomerList',
                link:'/Customers/CustomerList',
                icon:'IconUser',
                locale:'menu.customerList',
                auth:['1','2','3','4','5','8','10','12','13','15','18']
            },
            {
                name:'经销商管理',
                key:'DealerList',
                link:'/Customers/DealerList',
                icon:'IconUserGroup',
                locale:'menu.dealerList',
                auth:['1','2','3','4','5','8','10','12','13','15','18']
            },
        ]
    },
    {
        name:'产品管理',
        key:'Product',
        link:'/Product',
        icon:'IconCommon',
        locale:'menu.productList',
        auth:['1','2','3','4','5','8','10','12','13','15','17','18'],
        children:[
            {
                name:'产品管理',
                key:'ProductList',
                link:'/Product/ProductList',
                icon:'IconCommon',
                locale:'menu.productList',
                auth:['1','2','3','4','5','8','10','12','13','15','17','18'],
            },
            {
                name:'交付维护',
                key:'ProductList',
                link:'/Product/ProductPlanList',
                icon:'IconEdit',
                locale:'menu.availabilityEdit',
                auth:['1','2','3','4','5','8','10','12','13','15','17','18'],
            },
        ]
    },
    {
        name:'基础配置',
        key:'Config',
        link:'/Config',
        icon:'IconRelation',
        locale:'menu.config',
        auth:['1','2','4','10','12','13','15','18'],
        children:[
            {
                name:'国家代码配置',
                key:'countryCodeConfig',
                link:'/Config/CountryCodeConfig',
                icon:'IconPublic',
                locale:'menu.countryCodeConfig',
                auth:['1','2','4','10','12','13','15','18'],
            },
            {
                name:'区域销售经理配置',
                key:'areaSaleManagerConfig',
                link:'/Config/AreaSaleManagerConfig',
                icon:'IconUserAdd',
                locale:'menu.areaSaleManagerConfig',
                auth:['1','2','4','10','12','13','15','18'],
            },
            {
                name:'邮件接收配置',
                key:'EmailReceive',
                link:'/Config/EmailReceive',
                icon:'IconEmail',
                locale:'menu.emailReceive',
                auth:['1','2','4','10','12','13','15','18'],
            },
            {
                name:'经销商发货日期区间配置',
                key:'DeliveryDateRangeConfig',
                link:'/Config/DeliveryDateRangeConfig',
                icon:'IconSun',
                locale:'menu.deliveryDateRangeConfig',
                auth:['1','2','4','10','12','13','15','18'],
            },
        ]
    },
    {
        name:'财务管理',
        key:'Financial',
        link:'/Financial',
        icon:'IconSafe',
        locale:'menu.financial',
        auth:['1','2','4','15','18'],
        children:[
            {
                name:'经销商目标',
                key:'DealerGoal',
                link:'/Financial/DealerGoal',
                icon:'IconUserAdd',
                locale:'menu.dealerGoal',
                auth:['1','2','4','15','18'],
            },
            {
                name:'销售车架目标',
                key:'SaleFrameGoal',
                link:'/Financial/SaleFrameGoal',
                icon:'IconStamp',
                locale:'menu.saleFrameGoal',
                auth:['1','2','4','15','18'],
            },
            {
                name:'财务收账',
                key:'FinancialReceipts',
                link:'/Financial/FinancialReceipts',
                icon:'IconSafe',
                locale:'menu.financialReceipts',
                auth:['1','2','4','15','18'] ,
            },
            {
                name:'现金流',
                key:'Cash',
                link:'/Financial/Cash',
                icon:'IconCopyright',
                locale:'menu.cash',
                auth:['1','2','4','15','18'],
            },
            {
                name:'应付',
                key:'Accounts',
                link:'/Financial/Accounts',
                icon:'IconTag',
                locale:'menu.accounts',
                auth:['1','2','4','15','18'],
            },
            {
                name:'同步订单来源',
                key:'OrderSource',
                link:'/Financial/OrderSource',
                icon:'IconSun',
                locale:'menu.orderSource',
                auth:['1','2','4','15','18'],
            },
            {
                name:'同步ERP价目表',
                key:'PriceList',
                link:'/Financial/PriceList',
                icon:'IconLoop',
                locale:'menu.priceList',
                auth:['1','2','4','15','18'],
            },
            {
                name:'税率配置',
                key:'TaxConfig',
                link:'/Financial/TaxConfig',
                icon:'IconSunFill',
                locale:'menu.taxConfig',
                auth:['1','2','4','15','18'],
            },
            {
                name:'发货签收',
                key:'SignatureList',
                link:'/Financial/SignatureList',
                icon:'IconSubscribed',
                locale:'menu.signatureList',
                auth:['1','2','4','15','18'],
            },
            
        ]
    },

    {
        name:'数据看板',
        key:'Dashboard',
        link:'/Dashboard',
        icon:'IconDashboard',
        locale:'menu.dashboard',
        auth:['1','2','3','4','5','8','10','12','13','15','17','18'],
        children:[
            {
                name:'KPI日报表',
                key:'KpiDailyReport',
                link:'/Dashboard/KpiDailyReport',
                icon:'IconBook',
                locale:'menu.kpiDailyReport',
                auth:['1','2','4','10','12','18']
            },
            {
                name:'整车库存',
                key:'ProductQuery',
                link:'/Dashboard/ProductQuery',
                icon:'IconSearch',
                locale:'menu.productQuery',
                auth:['1','2','3','4','5','10','12','13','15','17','18']
            },
        ]
    },

    {
        name:'系统日志',
        // key:'ErrorLog',
        // link:'/ErrorLog',
        key:'Log',
        link:'/Log',
        icon:'IconBug',
        locale:'menu.log',
        auth:['1','2'],
        children:[
            {
                name:'报错日志',
                key:'ErrorLog',
                link:'/Log/ErrorLog',
                icon:'IconBug',
                locale:'menu.errorLog',
                auth:['1','2','4','10','12','13','15'],
            },
            {
                name:'操作日志',
                key:'OperationLog',
                link:'/Log/OrderRiskVerificationLog',
                icon:'IconBug',
                locale:'menu.orderRiskVerificationLog',
                auth:['1','2','4','10','12','13','15'],
            },
        ],
    },

    {
        name:'历史',
        // key:'ErrorLog',
        // link:'/ErrorLog',
        key:'History',
        link:'/History',
        icon:'IconUndo',
        locale:'menu.history',
        auth:['1','2','4','10','12','13','18'],
        children:[
            {
                name:'退货杂单管理',
                key:'ReturnOrder',
                link:'/History/ReturnOrder',
                icon:'IconUndo',
                locale:'menu.returnOrder',
                auth:['1','2','3','4','5','8','10','12','13','15','18']
            },
            {
                name:'经销商业务订单管理',
                key:'DealerBusinessOrder',
                link:'/History/DealerBusinessOrder',
                icon:'IconSelectAll',
                locale:'menu.preOrderList',
                auth:['1','2','4','10','12','13','18']
            },
            {
                name:'经销商业务订单审核列表',
                key:'OrderApprovalList',
                link:'/History/OrderApprovalList',
                icon:'IconStamp',
                locale:'menu.orderApprovalList',
                auth:['1','2','4','10','11','12','13','18']
            },
        ],
    },
    // {
    //     name:'出库管理',
    //     key:'StockOutList',
    //     link:'/StockOutList',
    //     icon:'IconStorage',
    //     locale:'menu.stockOutList',
    //     auth:['1','2','3','4','5','6','7','8','10','12','13','15','16']
    // },
    // {
    //     name:'库存锁定',
    //     key:'InventoryLockList',
    //     link:'/InventoryLockList',
    //     icon:'IconLock',
    //     locale:'menu.inventoryLock',
    //     auth:['1','2','3','4','5','6','7','8','10','12','13','15','16']
    // },
    // {
    //     name:'B2B Shop订单管理',
    //     key:'B2BShopOrderList',
    //     link:'/B2BShopOrderList',
    //     icon:'IconList',
    //     locale:'menu.B2BShopOrderList',
    //     auth:['1','10','12']
    // },
    // {
    //     name:'经销商延期订单',
    //     key:'DealerOpenOrderList',
    //     link:'/DealerOpenOrderList',
    //     icon:'IconOrderedList',
    //     locale:'menu.dealerOpenOrder',
    //     auth:['1','2','4','5','8','10','12','13','15','16']
    // },
    // {
    //     name:'经销商业务订单管理',
    //     key:'DealerBusinessOrder',
    //     link:'/DealerBusinessOrder',
    //     icon:'IconSelectAll',
    //     locale:'menu.preOrderList',
    //     auth:['1','4','10','12','13']
    // },
    // {
    //     name:'经销商业务订单审核列表',
    //     key:'OrderApprovalList',
    //     link:'/OrderApprovalList',
    //     icon:'IconStamp',
    //     locale:'menu.orderApprovalList',
    //     auth:['1','4','10','11','12','13']
    // },
    // {
    //     name:'计划管理',
    //     key:'ProductPlanList',
    //     link:'/ProductPlanList',
    //     icon:'IconLayers',
    //     locale:'menu.productPlanList',
    //     auth:['1','2','3','5','8','10','12','13','15']
    // },
    // {
    //     name:'退货杂单管理',
    //     key:'ReturnOrder',
    //     link:'/ReturnOrder',
    //     icon:'IconUndo',
    //     locale:'menu.returnOrder',
    //     auth:['1','2','3','4','5','8','10','12','13','15']
    // },
    // {
    //     name:'发票管理',
    //     key:'InvoiceList',
    //     link:'/InvoiceList',
    //     icon:'IconFile',
    //     locale:'menu.invoiceList',
    //     auth:['1','2','3','4','8','10','12','13','15','16']
    // },
    // {
    //     name:'产品管理',
    //     key:'Product',
    //     link:'/Product',
    //     icon:'IconCommon',
    //     locale:'menu.productList',
    //     auth:['1','2','3','4','5','8','10','12','13','15','17'],
    //     children:[
    //         {
    //             name:'产品管理',
    //             key:'ProductList',
    //             link:'/Product/ProductList',
    //             icon:'IconCommon',
    //             locale:'menu.productList',
    //             auth:['1','2','3','4','5','8','10','12','13','15','17'],
    //         },
    //         {
    //             name:'整车部件查询',
    //             key:'BomQuery',
    //             link:'/Product/BomQuery',
    //             icon:'IconSearch',
    //             locale:'menu.bomQuery',
    //             auth:['1','2','3','4','5','8','10','12','13','15'],
    //         },
    //     ]
    // },
    // {
    //     name:'Ebike交付管理',
    //     key:'Deliver',
    //     link:'/Deliver',
    //     icon:'IconLayers',
    //     locale:'menu.eBikeAvailability',
    //     auth:['1','2','3','4','5','8','10','12','13','15','17'],
    //     children:[
    //         {
    //             name:'交付维护',
    //             key:'ProductList',
    //             link:'/Deliver/ProductPlanList',
    //             icon:'IconEdit',
    //             locale:'menu.availabilityEdit',
    //             auth:['1','2','3','4','5','8','10','12','13','15','17'],
    //         },
    //         {
    //             name:'交付报表',
    //             key:'BomQuery',
    //             link:'/Deliver/AvailabilityReport',
    //             icon:'IconMindMapping',
    //             locale:'menu.availabilityReport',
    //             auth:['1','2','3','4','5','8','10','12','13','15','17'],
    //         },
    //         {
    //             name:'整车库存',
    //             key:'ProductQuery',
    //             link:'/Deliver/ProductQuery',
    //             icon:'IconSearch',
    //             locale:'menu.productQuery',
    //             auth:['1','2','3','4','5','10','12','13','15','17']
    //         },
    //     ]
    // },
    // {
    //     name:'产品查询',
    //     key:'ProductQuery',
    //     link:'/ProductQuery',
    //     icon:'IconSearch',
    //     locale:'menu.productQuery',
    //     auth:['1','2','3','4','5','10','12','13','15']
    // },
    // {
    //     name:'客户管理',
    //     key:'CustomerList',
    //     link:'/CustomerList',
    //     icon:'IconUser',
    //     locale:'menu.customerList',
    //     auth:['1','2','3','4','5','8','10','12','13','15']
    // },
    // {
    //     name:'经销商管理',
    //     key:'DealerList',
    //     link:'/DealerList',
    //     icon:'IconUserGroup',
    //     locale:'menu.dealerList',
    //     auth:['1','2','3','4','5','10','12','13','15']
    // },
    // {
    //     name:'预警管理',
    //     key:'WarningList',
    //     link:'/WarningList',
    //     icon:'IconBulb',
    //     locale:'menu.warningList',
    //     auth:['1','2']
    // },
    // {
    //     name:'销售目标',
    //     key:'SaleGoal',
    //     link:'/SaleGoal',
    //     icon:'IconTrophy',
    //     locale:'menu.saleGoal',
    //     auth:['1','2','4','15'],
    //     children:[
    //         {
    //             name:'经销商目标',
    //             key:'DealerGoal',
    //             link:'/SaleGoal/DealerGoal',
    //             icon:'IconUserAdd',
    //             locale:'menu.dealerGoal',
    //             auth:['1','2','4','15'],
    //         },
    //         {
    //             name:'销售车架目标',
    //             key:'SaleFrameGoal',
    //             link:'/SaleGoal/SaleFrameGoal',
    //             icon:'IconStamp',
    //             locale:'menu.saleFrameGoal',
    //             auth:['1','2','4','15'],
    //         },
    //     ]
    // },
    // {
    //     name:'财务管理',
    //     key:'Financial',
    //     link:'/Financial',
    //     icon:'IconSafe',
    //     locale:'menu.financial',
    //     auth:['1','2','4','15'],
    //     children:[
    //         {
    //             name:'财务收账',
    //             key:'FinancialReceipts',
    //             link:'/Financial/FinancialReceipts',
    //             icon:'IconSafe',
    //             locale:'menu.financialReceipts',
    //             auth:['1','2','4','15'],
    //         },
    //         {
    //             name:'现金流',
    //             key:'Cash',
    //             link:'/Financial/Cash',
    //             icon:'IconCopyright',
    //             locale:'menu.cash',
    //             auth:['1','2','4','15'],
    //         },
    //         {
    //             name:'应付',
    //             key:'Accounts',
    //             link:'/Financial/Accounts',
    //             icon:'IconTag',
    //             locale:'menu.accounts',
    //             auth:['1','2','4','15'],
    //         },
    //         {
    //             name:'同步订单来源',
    //             key:'OrderSource',
    //             link:'/Financial/OrderSource',
    //             icon:'IconSun',
    //             locale:'menu.orderSource',
    //             auth:['1','2','4','15'],
    //         },
    //         {
    //             name:'同步ERP价目表',
    //             key:'PriceList',
    //             link:'/Financial/PriceList',
    //             icon:'IconLoop',
    //             locale:'menu.priceList',
    //             auth:['1','2','4','15'],
    //         },
    //         {
    //             name:'税率配置',
    //             key:'TaxConfig',
    //             link:'/Financial/TaxConfig',
    //             icon:'IconSunFill',
    //             locale:'menu.taxConfig',
    //             auth:['1','2','4','15'],
    //         },
    //         {
    //             name:'发货签收',
    //             key:'SignatureList',
    //             link:'/Financial/SignatureList',
    //             icon:'IconSubscribed',
    //             locale:'menu.signatureList',
    //             auth:['1','2','4','15'],
    //         },
    //         // {
    //         //     name:'经销商等级配置',
    //         //     key:'DealerLevelConfig',
    //         //     link:'/Financial/DealerLevelConfig',
    //         //     icon:'IconPushpin',
    //         //     locale:'menu.dealerLevelConfig',
    //         //     auth:['1','2','4','15'],
    //         // },
    //         // {
    //         //     name:'邮件接收配置',
    //         //     key:'EmailReceive',
    //         //     link:'/Financial/EmailReceive',
    //         //     icon:'IconEmail',
    //         //     locale:'menu.emailReceive',
    //         //     auth:['1','2','4','15'],
    //         // },
            
    //     ]
    // },
    // {
    //     name:'报错日志',
    //     // key:'ErrorLog',
    //     // link:'/ErrorLog',
    //     key:'Log',
    //     link:'/Log',
    //     icon:'IconBug',
    //     locale:'menu.log',
    //     auth:['1','2'],
    //     children:[
    //         {
    //             name:'报错日志',
    //             key:'ErrorLog',
    //             link:'/Log/ErrorLog',
    //             icon:'IconBug',
    //             locale:'menu.errorLog',
    //             auth:['1','2','4','10','12','13','15'],
    //         },
    //         {
    //             name:'操作日志',
    //             key:'OperationLog',
    //             link:'/Log/OrderRiskVerificationLog',
    //             icon:'IconBug',
    //             locale:'menu.orderRiskVerificationLog',
    //             auth:['1','2','4','10','12','13','15'],
    //         },
    //     ],
    // },
    // {
    //     name:'基础配置',
    //     key:'Config',
    //     link:'/Config',
    //     icon:'IconRelation',
    //     locale:'menu.config',
    //     auth:['1','2','4','10','12','13','15'],
    //     children:[
    //         // {
    //         //     name:'SO同步过滤配置',
    //         //     key:'SOSyncConf',
    //         //     link:'/Config/SOSyncConf',
    //         //     icon:'IconRelation',
    //         //     locale:'menu.soSyncConf'
    //         //     auth:['1','2','4','10','12','13','15'],
    //         // },
    //         // {
    //         //     name:'同步订单来源',
    //         //     key:'OrderSource',
    //         //     link:'/Config/OrderSource',
    //         //     icon:'IconRelation',
    //         //     locale:'menu.orderSource',
    //         //     auth:['1','2','4','10','12','13','15'],
    //         // },
    //         {
    //             name:'邮件接收配置',
    //             key:'EmailReceive',
    //             link:'/Config/EmailReceive',
    //             icon:'IconEmail',
    //             locale:'menu.emailReceive',
    //             auth:['1','2','4','10','12','13','15'],
    //         },
    //         {
    //             name:'国家代码配置',
    //             key:'countryCodeConfig',
    //             link:'/Config/CountryCodeConfig',
    //             icon:'IconPublic',
    //             locale:'menu.countryCodeConfig',
    //             auth:['1','2','4','10','12','13','15'],
    //         },
    //         // {
    //         //     name:'销售经销商配置',
    //         //     key:'saleDealerConfig',
    //         //     link:'/Config/SaleDealerConfig',
    //         //     icon:'IconUserAdd',
    //         //     locale:'menu.saleDealerConfig',
    //         //     auth:['1','2','4','10','12','13','15'],
    //         // },
    //         {
    //             name:'区域销售经理配置',
    //             key:'areaSaleManagerConfig',
    //             link:'/Config/AreaSaleManagerConfig',
    //             icon:'IconUserAdd',
    //             locale:'menu.areaSaleManagerConfig',
    //             auth:['1','2','4','10','12','13','15'],
    //         },
    //         {
    //             name:'经销商发货日期区间配置',
    //             key:'DeliveryDateRangeConfig',
    //             link:'/Config/DeliveryDateRangeConfig',
    //             icon:'IconSun',
    //             locale:'menu.deliveryDateRangeConfig',
    //             auth:['1','2','4','10','12','13','15'],
    //         },
    //     ]
    // },
    {
        name:'系统设置',
        key:'Setting',
        link:'/Setting',
        icon:'IconSettings',
        locale:'menu.setting',
        auth:['1'],
        children:[
            // {
            //     name:'菜单管理',
            //     key:'MenuManage',
            //     link:'/Setting/MenuManage',
            //     icon:'IconList',
            //     locale:'menu.menuManage',
            //     auth:['2'],
            // },
            {
                name:'角色权限管理',
                key:'Role',
                link:'/Setting/Role',
                icon:'IconLock',
                locale:'menu.role',
                auth:['1'],
            },
            {
                name:'用户角色管理',
                key:'User',
                link:'/Setting/User',
                icon:'IconUserGroup',
                locale:'menu.user',
                auth:['1'],
            },
            {
                name:'用邮箱注册管理',
                key:'AddEmail',
                link:'/Setting/AddEmail',
                icon:'IconEmail',
                locale:'menu.addEmail',
                auth:['1'],
            },
        ]
    }
]

export {
    menus
}